import {TableCell, TableRow} from "@material-ui/core";
import _ from "lodash";
import React from "react";
import {makeStyles} from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  inheritFontWeight: {
    fontWeight: 'inherit',
  }
}));


const keys = [
  { id: 'registerations_regulator', name: 'registerations_regulator' },
  { id: 'registerations_registeration', name: 'registerations_registeration' },
  { id: 'registerations_registeration_status', name: 'registerations_registeration_status' },
  { id: 'registerations_registeration_date', name: 'registerations_registeration_date' },
]

const RegistrationsRow = (props) => {
  const {registrations} = props;
  const classes = useStyles();

  return (
    registrations.map(((registration, index) =>
        <TableRow hover key={`${registration.attributes.registerations_regulator}-${index}`}>
          {keys.map(((key) =>
            <TableCell key={`${key.name}-${registration.attributes.registerations_regulator}`} className={classes.inheritFontWeight}>
              {_.isNil(registration.attributes[key.id]) ? '' : `${registration.attributes[key.id]}`}
            </TableCell>
          ))}
        </TableRow>
    ))
  )
}

export default RegistrationsRow;